import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ModalService } from '@services/modal/modal.service';
import { lastValueFrom } from 'rxjs';
import { Destination } from '../../schema/destination';
import { INavigationProvider } from '../../schema/interfaces/INavigationProvider';

@Injectable({
  providedIn: 'root'
})
export class TomTomProviderService implements INavigationProvider {
  constructor(private modalService: ModalService, private httpClient: HttpClient) {}

  navigateTo(destination: Destination) {
    this.modalService
      .presentLoading()
      .then(() =>
        lastValueFrom(
          this.httpClient.post('api/Navigation/StartWebfleetNavigation', {
            destinationType: destination.destinationType,
            id: destination.destinationId
          })
        )
      )
      .finally(() => this.modalService.dismissLoading());
  }
}
